import styled from 'styled-components';

type Props = {
  $text: string;
  $imgSrc?: string;
  $size?: 'small' | 'large';
};

const getBackgroundColor = (initials: string) => {
  const initialCode = initials.charCodeAt(0);
  if (initialCode <= 'D'.charCodeAt(0)) {
    return '#52C429';
  } else if (initialCode <= 'H'.charCodeAt(0)) {
    return '#ED8F94';
  } else if (initialCode <= 'L'.charCodeAt(0)) {
    return '#7ED5ED';
  } else if (initialCode <= 'P'.charCodeAt(0)) {
    return '#2FBCE2';
  } else if (initialCode <= 'T'.charCodeAt(0)) {
    return '#0693B9';
  } else if (initialCode <= 'Y'.charCodeAt(0)) {
    return '#A2C4FB';
  }
  return '#4076D0';
};

const getAvatarSize = (size) => (size === 'small' ? '32px' : '86px');
const getFontSize = (size) => (size === 'small' ? '1em' : '3em');

export const AvatarContainer = styled.div<Props>`
  background-color: ${({ $text }) => getBackgroundColor($text)};
  height: ${({ $size }) => getAvatarSize($size)};
  width: ${({ $size }) => getAvatarSize($size)};
  min-height: ${({ $size }) => getAvatarSize($size)};
  min-width: ${({ $size }) => getAvatarSize($size)};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.white};
  font-size: ${({ $size }) => getFontSize($size)};
  ${({ $imgSrc }) => `background-image: url(${$imgSrc})`};
  background-size: cover;
  text-transform: uppercase;
  background-position: top center;
`;
